import React from "react";

import "./SubHeader.scss";
import GridIcon from "../../assets/icons/grid.svg";
import ListIcon from "../../assets/icons/list.svg";
import Close from "../../assets/icons/close.svg";
import SelectAllCheckBox from "../UI/CheckBox/SelectAllCheckBox/SelectAllCheckBox";
import Filter from "../Filter/Filter";
import DownloadDropDown from "../UI/DownloadDropDown/DownloadDropDown";
import DropDown from "../UI/DropDown/DropDown";
import DateRange from "../UI/DateRange/DateRange";
import SavedViewsContainer from "../SavedViewsContainer/SavedViewsContainer";
import InstructionBulb from "../InstructionBulb/InstructionBulb";

const FolderRoute = ({searchValue, setSearchValue, searchPlaceholder, handleSavedViewsApply, ...props}) => {
  const [isGridView, setIsGridView] = React.useState(false)

  const getInstructionString = () => {
    let instruction = ""
    if (props.isFoldersView) {
      // Root folder
      const currentFolder = props.rootFolders.find((folder) => folder.id === props.match.params.folderId)
      if(currentFolder) {
        instruction = currentFolder.instruction
      }
    } else {
      // Sub folder
      if(props.subFolders[props.match.params.folderId] ) {
        const currentFolder = props.subFolders[props.match.params.folderId].find(
          (subFolder) => subFolder.id === props.match.params.subId
        )
        if(currentFolder) {
          instruction = currentFolder.instruction
        }
      }
    }
    return instruction
  }
  
  const getContentRole = (userRoleId) => {
    const folder =
      props.subFolders[props.match.params.folderId] &&
      props.subFolders[props.match.params.folderId].find(
        (subFolder) => subFolder.id === props.match.params.subId
      );
    if (userRoleId === 1 || userRoleId === 2) {
      return true;
    } else if (folder) {
      const createUserId = folder.createdBy.id;
      const logUserId = props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = true;
      } else {
        const sharedUsers = folder.sharedFolder.map((sharedItem) => {
          return {
            id: sharedItem.user.id,
            role: sharedItem.userRole.name,
          };
        });
        const getAccess = sharedUsers.find(
          (sharedUser) =>
            sharedUser.id === logUserId &&
            (sharedUser.role === "Owner" ||
              sharedUser.role === "Collaborator" ||
              sharedUser.role === "Viewer")
        );
        returnedVal = getAccess ? true : false;
      }
      return returnedVal;
    }
  };

  const checkRole = (type) => {
    if (props.isFoldersView) {
      if (props.userRoleId === 1 || props.userRoleId === 2) {
        return true;
      } else {
        const filterSubFolders = props.subFolders.filter(
          (subFolder) => props.checkedItems[subFolder.id]
        );

        const check =
          type === "Owner"
            ? filterSubFolders.filter((sub) => {
                const getLoginUser = sub.sharedFolder.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter((user) => user.userRole.name === "Owner")
                    .length === getLoginUser.length
                );
              }).length === filterSubFolders.length
            : filterSubFolders.filter((sub) => {
                const getLoginUser = sub.sharedFolder.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter(
                    (user) =>
                      user.userRole.name === "Owner" ||
                      user.userRole.name === "Collaborator"
                  ).length === getLoginUser.length
                );
              }).length === filterSubFolders.length;
        return check;
      }
    } else if (props.isDocumentView) {
      if (props.userRoleId === 1 || props.userRoleId === 2) {
        return true;
      } else {
        const filterDocuments = props.documents.filter(
          (document) => props.checkedItems[document.id]
        );

        const check =
          type === "Owner"
            ? filterDocuments.filter((sub) => {
                const getLoginUser = sub.sharedDocument.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter((user) => user.userRole.name === "Owner")
                    .length === getLoginUser.length
                );
              }).length === filterDocuments.length
            : filterDocuments.filter((sub) => {
                const getLoginUser = sub.sharedDocument.filter(
                  (user) => user.user.id === props.currentUserInfo.id
                );
                return (
                  getLoginUser.filter(
                    (user) =>
                      user.userRole.name === "Owner" ||
                      user.userRole.name === "Collaborator"
                  ).length === getLoginUser.length
                );
              }).length === filterDocuments.length;
        return check;
      }
    }
  };

  const onSearch = (e) => {
    const val = e.target.value;
    setSearchValue(val)
  }
  const getSearchBox = () => (
    <div className="search-box mr-2">
      <input
        type="text"
        maxLength="50"
        placeholder={searchPlaceholder}
        className="search-placeholder set-width"
        value={searchValue}
        onChange={onSearch}
      />
    </div>
  )

  const handleListGridToggle = () => {
    if(isGridView) {
      props.displayListHandler()
    } else {
      props.displayGridtHandler()
    }
    setIsGridView((isGridView) => !isGridView)
    
  }
  return (
    <div className="col mt-6 mb-8 folder-router">
      {props.isArchivedView ? (
        <div className="d-md-flex">
          <div className="ml-auto pr-2 pt-1">
            {props.totalChecked() && props.totalDocuments > 0 ? (
              <DropDown
                restoreHandler={props.restoreAllHandler}
                deleteHandler={props.deleteAllHandler}
                isArchivedDropdown={props.isArchivedView}
              />
            ) : null}
          </div>
          <DateRange setDateFilter={props.setDateFilter} />
          
          {(props.isDocumentArchive || props.isSubFolderArchive) && (
            <Filter
              isArchivedView={props.isArchivedView}
              isSubFolderArchive={props.isSubFolderArchive}
              isDocumentArchive={props.isDocumentArchive}
              categories={props.categories}
              filterApplyHandler={props.filterApplyHandler}
              documents={props.documents}
            />
          )}
        </div>
      ) : null}
      {props.isFoldersView ? (
        <div className="d-md-flex align-items-center">
          {getSearchBox()}
          <Filter
              isFoldersView={props.isFoldersView}
              subfolders={props.subFolders}
              filterApplyHandler={props.filterApplyHandler}
            />
          <InstructionBulb title={getInstructionString()} />
          
          {props.displayListView ? null : (
            <div className="d-md-flex ml-3 mr-3 align-items-center">
              <SelectAllCheckBox
                checked={props.checked}
                selectAllHandler={props.selectAllHandler}
              />
              <div style={{ whiteSpace: "nowrap" }}>Select all</div>
            </div>
          )}

          {props.totalChecked() > 0 ? (
            <>
              <div className="btn btn-tertiary custom-btn ml-3">
                <div style={{ whiteSpace: "nowrap" }}>
                  {props.totalChecked()} selected
                </div>
                <img
                  className="ml-1"
                  src={Close}
                  width="12"
                  height="12"
                  alt="close"
                  onClick={props.unselectAllHandler}
                />
              </div>
              {checkRole("Collaborator") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleShare}
                >
                  Share
                </div>
              ) : null}
              {checkRole("Owner") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleArchive}
                >
                  Archive
                </div>
              ) : null}
            </>
          ) : null}

          <div 
            className="list-action-button ml-auto" 
            onClick={handleListGridToggle}
            >
              <img src={isGridView ? ListIcon : GridIcon } alt="Grid List button" />
          </div>

        </div>
      ) : null}
      {props.isDocumentView ? (
        <div className="d-md-flex align-items-center">
          {getSearchBox()}
          <Filter
              isDocumentView={props.isDocumentView}
              documents={props.documents}
              loadDocuments={props.loadDocuments}
              filterApplyHandler={props.filterApplyHandler}
            />
          <InstructionBulb title={getInstructionString()} />
          {props.displayListView ? null : (
            <div className="d-md-flex mx-3 align-items-center">
              <SelectAllCheckBox
                checked={props.checked}
                selectAllHandler={props.selectAllHandler}
              />
              <div style={{ whiteSpace: "nowrap" }}>Select all</div>
            </div>
          )}
          {props.totalChecked() > 0 ? (
            <>
              <div className="btn btn-tertiary text-auto custom-btn ml-3">
                {props.totalChecked()} selected
                <img
                  className="ml-1"
                  src={Close}
                  width="12"
                  height="12"
                  alt="close"
                  onClick={props.unselectAllHandler}
                />
              </div>
              {checkRole("Owner") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.showMoveFileModal}
                >
                  Move
                </div>
              ) : null}
              {checkRole("Collaborator") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleShare}
                >
                  Share
                </div>
              ) : null}
              {checkRole("Owner") ? (
                <div
                  className="btn btn-secondary custom-btn ml-3"
                  onClick={props.handleArchive}
                >
                  Archive
                </div>
              ) : null}
            </>
          ) : null}
          <div className="ml-auto d-flex pl-3">
            {
              !props.isSearchDocuments ? (
                <>
                  <SavedViewsContainer 
                    {...{ 
                      handleSavedViewsApply, 
                      selectedColumns: props.selectedColumns, 
                      folderId: props.match.params.folderId 
                      }
                    }/>

                  {getContentRole(props.userRoleId) ? (
                    <DownloadDropDown {...props} />
                  ) : null}
                </>
              ) : null
            }            

            <div 
              className="list-action-button ml-auto" 
              onClick={handleListGridToggle}
              >
                <img src={isGridView ? ListIcon : GridIcon } alt="Grid List button" />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FolderRoute;
